import React, { useState, useEffect, useRef } from 'react'
import { Button } from 'syngenta-react-components'
import clear from '../../../assets/icons/clear.svg'
import { searchCompanies, postLinkCompanies, searchCompaniesBySAP } from '../../../services/apiHelper'
import { useForm } from 'react-hook-form'
import TypeAhead from '../../../dpe-usco/components/TypeAhead/TypeAhead'
import { useParams } from 'react-router-dom'

const LinkedCompaniesForm = ({ handleClose, parentCompanyName }) => {
  const { company_id } = useParams()
  const [existingCompanies, setExisitingCompanies] = useState()
  const [selectedFromSearch, setSelectedFromSearch] = useState()
  const [stopSearch, setStopSearch] = useState(false)
  const [invitationStatus, setInvitationStatus] = useState()
  const { register, errors, clearError, handleSubmit, reset, setValue, watch } = useForm({})

  const watchCompanyName = watch('name', '')
  
  const canceled = useRef(false)
  useEffect(()=> {
    return () => {
      canceled.current = true
    }
  }, [])

  const fetchCompanies = async companyName => {
    companyName = companyName.substring(0,1) === '1' && companyName.length === 8 ? '00' + companyName : companyName
    const searchFn = (companyName.substring(0, 2) === '00' && companyName.length >= 10) 
      ? searchCompaniesBySAP
      : searchCompanies
    
    try {
      const res = await searchFn(companyName)
      if (!canceled.current) {
        setExisitingCompanies(res)
      }
    } catch (error) {
      console.error('Error fetching companies:', error)
    }
  }

  useEffect(() => {
    if (watchCompanyName.length > 2 && !stopSearch) {
      fetchCompanies(watchCompanyName)
      if (!canceled.current) {
        setStopSearch(true)
      }
    }
  }, [watchCompanyName, stopSearch])

  useEffect(() => {
    setInvitationStatus()
  }, [handleClose]) 

  const onSubmit = async () => {
    setInvitationStatus('LOADING')
    const postObj = {
      company_id_1: company_id,
      company_id_2: selectedFromSearch
    }
    const response = await postLinkCompanies(postObj)
    if(response) {
      setInvitationStatus('SUCCESS')
      reset()
      clearError()
    } else {
      setInvitationStatus('FAIL')
    }
  }

  const handleCancelModal = result => {
    reset()
    clearError()
    handleClose(result)
    setInvitationStatus()
  }

  const _nameCallback = val => {
    setValue('name', val.name)
    setSelectedFromSearch(val.company_id)
  }

  let bottomButtons = (
    <>
      <Button text='Cancel' customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4' clickHandler={() => handleCancelModal('CLOSE')}/>
      <Button type='success' text='Link Company' clickHandler={handleSubmit(onSubmit)} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
    </>
  )

  let content = (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='df fxdrr jcsb'>
        <div className='w45% tal'>
          <div className='mt20 ml20'>
            <label htmlFor='name'>Search Company:</label>
            <TypeAhead className='fz15 lh1.4' id='name' name='name' placeholder='Search company'
              ref={register({ required: true })}
              item_id='company_id'
              item_value='name'
              data={existingCompanies}
              callback={_nameCallback}
              onChange={() => setStopSearch(false)}
              showSAPandState={true}
            />
          </div>
          <div className='c-red tal fz13 pl4'>
            {errors.name && errors.name.type === 'required' && 'Please provide a company'}
            {errors.name && errors.name.type === 'pattern' &&
                    'This company appears to be invalid. Please check if anything is missing'
            }
          </div>
        </div>
      </div>
    </form>
  )

  switch(invitationStatus){
    case 'LOADING' : 
      content = (
        <div className='df fxdrr jcsb'>
          <div className='w100% tac'>
            <p>Linking Companies. Please wait...</p>
          </div>
        </div>
      )
      break
    case 'SUCCESS':
      content = (
        <div className='df fxdrr jcsb'>
          <div className='w100% tac'>
            <p>{`Successfully linked to ${parentCompanyName}`}</p>
          </div>
        </div>
      )
      bottomButtons = (
        <Button type='success' text='Close' clickHandler={() => handleCancelModal('SUCCESS')} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    case 'FAIL':
      content = (
        <div className='df fxdrr jcsb'>
          <div className='w100% tac'>
            <p>Something went wrong. Please try again later.</p>
          </div>
        </div>
      )
      bottomButtons = (
        <Button type='success' text='Close' clickHandler={() => handleCancelModal('CLOSE')} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    default:
      break
  }

  return (
    <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
      <div className='df jcsb'>
        <p className='fz16 ml16 fw600'>Link Company</p>
        <button className='bdnone m0 bgc-t' onClick={() => handleCancelModal('CLOSE')}>
          <img src={clear} alt='cancel button' />
        </button>
      </div>
      <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
      {content}
      <hr className='mt20 mb16 bdnone bt1-s-lightgray' />
      <div className='df jcfe'>
        {bottomButtons}
      </div>
    </div>
  )
}

export default LinkedCompaniesForm